import { render, staticRenderFns } from "./section-period-chart.vue?vue&type=template&id=4a51ec17&scoped=true"
import script from "./section-period-chart.vue?vue&type=script&lang=js"
export * from "./section-period-chart.vue?vue&type=script&lang=js"
import style0 from "./section-period-chart.vue?vue&type=style&index=0&id=4a51ec17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a51ec17",
  null
  
)

export default component.exports